import {lazy} from 'react';
import SkeletonOrderSummary from '../../../pages/SkeletonPage/SkeletonOrderSummary';
import GenericFallbackSuspense from '../ui/GenericFallback/GenericFallbackSuspense';

const OrderSummary = lazy(() => import('./OrderSummary'));

function OrderSummaryLazyLoader(props) {
  return (
    <GenericFallbackSuspense fallback={<SkeletonOrderSummary />}>
      <OrderSummary {...props} />
    </GenericFallbackSuspense>
  );
}

export default OrderSummaryLazyLoader;
